import FeatureTrackingBuilder from '@utils/feature_tracking_builder';

class FeatureTracking {
    $id: string;
    $name: string;
    $status: FeatureStatus;
    $position: number | null | undefined = null;
    $parentId: string | null | undefined = null;
    $variationId: string | null | undefined = null;
    $labels: object | null | undefined = null;

    constructor(featureTrackingPayloadBuilder: FeatureTrackingBuilder) {
        this.$id = featureTrackingPayloadBuilder.getId();
        this.$name = featureTrackingPayloadBuilder.getName();
        this.$status = featureTrackingPayloadBuilder.getStatus();
        this.$position = featureTrackingPayloadBuilder.getPosition();
        this.$parentId = featureTrackingPayloadBuilder.getParentId();
        this.$variationId = featureTrackingPayloadBuilder.getVariationId();
        this.$labels = featureTrackingPayloadBuilder.getLabels();
    }

    generateFeatureTrackingPayload() {
        const payload: any = {
            id: this.$id,
            name: this.$name,
            status: this.$status.toString()
        };
        if (this.$position !== undefined && this.$position !== null) payload.position = this.$position;
        if (this.$parentId) payload.parentId = this.$parentId;
        if (this.$variationId) payload.variationId = this.$variationId;
        if (this.$labels) {
            payload.labels = this.$labels;
        } else {
            payload.labels = {};
        }
        return payload;
    }

}

enum FeatureStatus {
    CLICKED = 'clicked',
    DESELECTED = 'deselected',
    DISABLED = 'disabled',
    ERROR = 'error',
    HIDDEN = 'hidden',
    LOADED = 'loaded',
    MANDATORY = 'mandatory',
    PRESELECTED = 'preselected',
    SELECTED = 'selected',
    SUCCESS = 'success',
    VISIBLE = 'visible',
    EXPANDED = 'expanded',
    COLLAPSED = 'collapsed'
}

enum ActionType {
    CLICK = 'click',
    COLLAPSE = 'collapse',
    EXPAND = 'expand',
    NEXT = 'next',
    SCROLL = 'scroll',
    SELECT = 'select',
    AUTOMATIC = 'automatic'
}

export {FeatureTracking, FeatureStatus, ActionType}